import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { redirectToCanonicalOrigin } from './lib/canonicalOrigin';
import './index.css';

// Build marker — bump to invalidate browser cache. Referenced in
// the app bootstrap so it is not tree-shaken and forces Vite to emit
// a new main-bundle hash.
export const BUILD_TAG = 'bba8352d-2026-08-05-cache-bust';

async function prepare() {
  // A non-canonical hostname (e.g. the legacy staging.ai.sys9.co) must never
  // start the Logto flow: its origin is not a registered redirect URI.
  if (redirectToCanonicalOrigin()) {
    return new Promise<never>(() => undefined); // navigation in flight
  }
  if (import.meta.env?.VITE_USE_MOCK_API === 'true') {
    const { worker } = await import('./mocks/browser');
    return worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
}

prepare().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
});
// Rebuild trigger: พ.  5 ส.ค. 2569 18:43:56 +07
